type SectionHeadingProps = {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
  light?: boolean;
  align?: 'left' | 'center';
};

export default function SectionHeading({
  index,
  eyebrow,
  title,
  desc,
  light = false,
  align = 'left',
}: SectionHeadingProps) {
  const titleColor = light ? 'text-background-50' : 'text-foreground-950';
  const descColor = light ? 'text-background-300' : 'text-foreground-600';
  const eyebrowColor = light ? 'text-primary-300' : 'text-accent-700';
  const lineColor = light ? 'bg-primary-400' : 'bg-accent-500';

  return (
    <div className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'}>
      <div
        className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`}
      >
        <span className={`h-px w-8 ${lineColor}`}></span>
        <span className={`text-xs font-bold tracking-[0.25em] ${eyebrowColor}`}>
          {index} / {eyebrow}
        </span>
      </div>
      <h2 className={`mt-4 font-heading text-2xl font-black leading-tight tracking-tight md:text-4xl ${titleColor}`}>
        {title}
      </h2>
      {desc ? (
        <p className={`mt-3 text-sm leading-7 md:text-base ${descColor}`}>{desc}</p>
      ) : null}
    </div>
  );
}